"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAnchor = exports.serializeCredential = exports.serializeCoin = exports.serializeOptionFlag = exports.path_to_buf = exports.buf_to_hex = exports.hex_to_buf = exports.int64_to_buf = exports.uint64_to_buf = exports.buf_to_uint32 = exports.uint32_to_buf = exports.buf_to_uint16 = exports.uint16_to_buf = exports.uint8_to_buf = void 0;
const int64_buffer_1 = require("int64-buffer");
const assert_1 = require("./assert");
const parse_1 = require("./parse");
function uint8_to_buf(value) {
    (0, assert_1.assert)((0, parse_1.isUint8)(value), 'invalid uint8');
    const data = Buffer.alloc(1);
    data.writeUInt8(value, 0);
    return data;
}
exports.uint8_to_buf = uint8_to_buf;
function uint16_to_buf(value) {
    (0, assert_1.assert)((0, parse_1.isUint16)(value), 'invalid uint16');
    const data = Buffer.alloc(2);
    data.writeUInt16BE(value, 0);
    return data;
}
exports.uint16_to_buf = uint16_to_buf;
function buf_to_uint16(data) {
    (0, assert_1.assert)(data.length === 2, 'invalid uint16 buffer');
    return data.readUIntBE(0, 2);
}
exports.buf_to_uint16 = buf_to_uint16;
function uint32_to_buf(value) {
    (0, assert_1.assert)((0, parse_1.isUint32)(value), 'invalid uint32');
    const data = Buffer.alloc(4);
    data.writeUInt32BE(value, 0);
    return data;
}
exports.uint32_to_buf = uint32_to_buf;
function buf_to_uint32(data) {
    (0, assert_1.assert)(data.length === 4, 'invalid uint32 buffer');
    return data.readUIntBE(0, 4);
}
exports.buf_to_uint32 = buf_to_uint32;
function uint64_to_buf(value) {
    (0, assert_1.assert)((0, parse_1.isUint64str)(value), 'invalid uint64_str');
    const data = new int64_buffer_1.Uint64BE(value, 10).toBuffer();
    (0, assert_1.assert)(data.length === 8, 'invalid data length');
    return data;
}
exports.uint64_to_buf = uint64_to_buf;
function int64_to_buf(value) {
    (0, assert_1.assert)((0, parse_1.isInt64str)(value), 'invalid int64_str');
    const data = new int64_buffer_1.Int64BE(value, 10).toBuffer();
    (0, assert_1.assert)(data.length === 8, 'invalid data length');
    return data;
}
exports.int64_to_buf = int64_to_buf;
function hex_to_buf(data) {
    (0, assert_1.assert)((0, parse_1.isHexString)(data), 'invalid hex string');
    return Buffer.from(data, 'hex');
}
exports.hex_to_buf = hex_to_buf;
function buf_to_hex(data) {
    return data.toString('hex');
}
exports.buf_to_hex = buf_to_hex;
function path_to_buf(path) {
    (0, assert_1.assert)((0, parse_1.isValidPath)(path), 'invalid bip32 path');
    const data = Buffer.alloc(1 + 4 * path.length);
    data.writeUInt8(path.length, 0);
    for (let i = 0; i < path.length; i++) {
        data.writeUInt32BE(path[i], 1 + i * 4);
    }
    return data;
}
exports.path_to_buf = path_to_buf;
function serializeOptionFlag(included) {
    const SignTxIncluded = {
        NO: 1,
        YES: 2,
    };
    const value = included ? SignTxIncluded.YES : SignTxIncluded.NO;
    return uint8_to_buf(value);
}
exports.serializeOptionFlag = serializeOptionFlag;
function serializeCoin(coin) {
    return Buffer.concat([uint64_to_buf(coin)]);
}
exports.serializeCoin = serializeCoin;
function serializeCredential(credential) {
    switch (credential.type) {
        case 0:
            return Buffer.concat([
                uint8_to_buf(credential.type),
                path_to_buf(credential.path),
            ]);
        case 2:
            return Buffer.concat([
                uint8_to_buf(credential.type),
                hex_to_buf(credential.keyHashHex),
            ]);
        case 1:
            return Buffer.concat([
                uint8_to_buf(credential.type),
                hex_to_buf(credential.scriptHashHex),
            ]);
        default:
            (0, assert_1.unreachable)(credential);
    }
}
exports.serializeCredential = serializeCredential;
function serializeAnchor(anchor) {
    if (anchor == null) {
        return Buffer.concat([serializeOptionFlag(false)]);
    }
    else {
        return Buffer.concat([
            serializeOptionFlag(true),
            hex_to_buf(anchor.hashHex),
            Buffer.from(anchor.url, 'ascii'),
        ]);
    }
}
exports.serializeAnchor = serializeAnchor;
//# sourceMappingURL=data:application/json;base64,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